import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { UserX, ArrowLeft, RotateCcw } from "lucide-react";

export default function ForgotPasswordUserNotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const contact = (location.state as { contact?: string } | null)?.contact?.trim() || "";

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-blue-50 p-4">
      <Card className="w-full max-w-md shadow-xl border border-slate-200">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-3 w-14 h-14 rounded-full bg-red-100 flex items-center justify-center">
            <UserX className="w-7 h-7 text-red-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">Account not found</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-3 pt-2">
          <p className="text-gray-600 text-sm leading-relaxed">
            We could not find an account matching the details you entered.
          </p>
          {contact ? (
            <p className="text-sm font-medium text-gray-800 bg-slate-100 rounded-lg px-3 py-2 break-all">
              {contact}
            </p>
          ) : null}
          <p className="text-xs text-gray-500">
            Check your mobile number or email and try again, or contact your administrator.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col gap-3 pb-8">
          <Button
            type="button"
            className="w-full bg-blue-600 hover:bg-blue-700"
            onClick={() => navigate("/forgotpassword")}
          >
            <RotateCcw className="w-4 h-4 mr-2" />
            Try again
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={() => navigate("/login")}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to login
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
